import { GlobalStyles } from '@experiences/theme';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { isHostModeSelector } from '../../../store/selectors';
import UiAlertBanner from '../UiAlertBanner';

const useStyles = makeStyles(theme => (GlobalStyles(theme)));

export const UiHostDeprecationBanner: React.FC = () => {
    const classes = useStyles();
    const isHostMode = useSelector(isHostModeSelector);

    return (
        <>
            {isHostMode && (
                <div data-cy="ui-host-deprecation-banner">
                    <UiAlertBanner
                        type="warning"
                        closeable={false}>
                        <FormattedMessage
                            id="CLIENT_LICENSE_DEPRECATION_BANNER_FOR_HOST"
                            values={{
                                a: (chunk: string) => <a
                                    className={classes.a}
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://docs.uipath.com/overview/other/latest/overview/deprecation-timeline#automation-suite">
                                    {chunk}
                                </a>,
                                b: (chunk: string) => <a
                                    className={classes.a}
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://www.uipath.com/company/contact-us/licensing-queries-activations">
                                    {chunk}
                                </a>,
                            }}
                        />
                    </UiAlertBanner>
                </div>
            )}
        </>
    );
};
